<template>
  <div class="maintain">
    <div class="titli">
      <div class="ts">系统提示</div>
      <div>系统维护中...</div>
      <div>带来不便敬请谅解!</div>
    </div>
  </div>
</template>

<script>
import { other } from "@api/public";
let that;
export default {
  name: "maintain",
  data() {
    return {};
  },
  mounted() {
    that = this;
    document.addEventListener("visibilitychange", this.handleVisiable);
  },
  methods: {
    handleVisiable(e) {
      switch (e.target.visibilityState) {
        case "prerender":
          console.log("网页预渲染，内容不可见");
          break;
        case "hidden":
          console.log("内容不可见，处理后台、最小化、锁屏状态");
          break;
        case "visible":
          that.other2();
          break;
      }
    },
    other2() {
      other().then(res => {
        let site_close = res.data.site_close;
        if (site_close != 1) {
          that.$router.push({ path: "/" });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.maintain {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .titli {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 4rem;
    height: 2.4rem;
    background-color: #fff;
    border-radius: 0.16rem;
    font-size: 0.3rem;
    color: #333;
    .ts {
      text-align: center;
      width: 100%;
      padding-bottom: 0.2rem;
      font-size: 0.32rem;
      margin-bottom: 0.2rem;
      font-weight: bold;
      border-bottom: 1px solid #ccc;
    }
  }
}
</style>
